import { rewriteCreditText } from './rewriteCreditText';

const CART_MARKER = '.tn-cart-component';
const PRICE_SELECTOR = [
    '.tn-cart-item-summary__property--price-total',
    '.tn-cart-item-detail__list-item--price',
    '.tn-cart-totals__value',
].join(', ');
const CONTRIBUTIONS_SELECTOR = '.tn-cart__section--contributions';

interface OrderModel {
    cartItems?: Array<{ price?: number }>;
}

// TNEW renders the cart as data in an inline <script>: `var orderDataModel = {...};`.
// Parse it to gate on a REAL exchange signal (a negative-price line item = an
// exchanged-out credit) instead of trusting display text. Returns null if the model
// is absent or unparseable (→ caller does nothing, leaving the cart untouched).
function readOrderModel(): OrderModel | null {
    const scripts = Array.from(document.querySelectorAll('script:not([src])'));
    for (const script of scripts) {
        const text = script.textContent || '';
        const match = text.match(/var\s+orderDataModel\s*=\s*(\{[\s\S]*?\});/);
        if (match) {
            try {
                return JSON.parse(match[1]) as OrderModel;
            } catch {
                return null;
            }
        }
    }
    return null;
}

function isExchangeCart(model: OrderModel | null): boolean {
    return !!model?.cartItems?.some(
        item => typeof item.price === 'number' && item.price < 0
    );
}

// Rewrite only the price TEXT NODE in each cell so the sr-only "Price:" label survives.
function zeroCreditPrices(): void {
    document.querySelectorAll(PRICE_SELECTOR).forEach(cell => {
        cell.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue) {
                const updated = rewriteCreditText(node.nodeValue);
                if (updated !== node.nodeValue) {
                    node.nodeValue = updated;
                }
            }
        });
    });
}

function hideContributions(): void {
    document.querySelectorAll<HTMLElement>(CONTRIBUTIONS_SELECTOR).forEach(el => {
        el.style.display = 'none';
    });
}

export function initExchangeCartCleanup(): void {
    // Guard: only ever act on a TNEW cart page.
    if (!document.querySelector(CART_MARKER)) return;

    // Gate: only act when the cart data confirms an exchange (a credit line item).
    if (!isExchangeCart(readOrderModel())) return;

    zeroCreditPrices();
    hideContributions();
}
